<template>
  <div class="modal_wrap" :class="{ on: isOpen }">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">개통 유형 선택</h1>
        </div>
        <div class="modal_con">
          <!-- <div class="item_info">
            갤럭시 23시리즈 사전예약 시 사은품으로<br />
            <span class="red"
              >더블 스토리지 프로모션(512GB 제품을 256GB 제품 가격으로
              할인)</span
            >이 있어 일부 통신사에서는 256GB제품의 사전예약을 받지 않는 경우가
            있으니 참고하시기 바랍니다.
          </div> -->
          <!-- <div class="item_info">
            <div class="red">
              [제조사 프로모션-512GB upgrade]
            </div>
            사전 예약 후 예약 기간내 개통시 256GB 단말 가격으로 512GB 단말
            제공(플립5/폴드5 공통)
          </div> -->
          <div class="form_wrap">
            <div class="check_table" data-columns="">
              <!--'2열: data-columns="2"', '3열: data-columns="3"'-->
              <label v-for="(item, index) in items" :key="index"
                ><input
                  type="radio"
                  name="booking_item"
                  v-model="itemVal"
                  :value="item"
                /><span>{{ item }}</span></label
              >
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn bo grey" v-on:click="$emit('close')">
              닫기
            </button>
            <button class="btn" v-on:click="$emit('select', itemVal)">
              확인
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemModal',
  data() {
    return {
      items: [
        'iPhone 15 128GB',
        'iPhone 15 256GB',
        'iPhone 15 512GB',
        'iPhone 15 Plus 128GB',
        'iPhone 15 Plus 256GB',
        'iPhone 15 Plus 512GB',
        'iPhone 15 Pro 128GB',
        'iPhone 15 Pro 256GB',
        'iPhone 15 Pro 512GB',
        'iPhone 15 Pro 1TB',
        'iPhone 15 Pro Max 256GB',
        'iPhone 15 Pro Max 512GB',
        'iPhone 15 Pro Max 1TB',
      ],
      itemVal: 'iPhone 15 128GB',
      isOpen: false,
    };
  },
};
</script>
